import { createAction } from "@reduxjs/toolkit";
import type { CreateDocumentaryResourceBody } from "@shared-kernel/domain/types/documentary-resource";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const documentaryResourceCreate = createApiThunk<string, CreateDocumentaryResourceBody>(
  "documentaryResource/create",
  async (body: CreateDocumentaryResourceBody, { extra: { adminRepository } }) => {
    return adminRepository!.createDocumentaryResource(body);
  },
);

export const documentaryResourceCreateReset = createAction("documentaryResource/createReset");
